import { Component, inject, input, output, signal, effect, ChangeDetectionStrategy } from '@angular/core';
import { FormField, form, required, min, maxLength } from '@angular/forms/signals';
import { ReservaApiService } from '@core/services/api/reserva-api.service';
import { IReservaRecursoData } from '@core/interfaces/entidades/reserva.entidad';
import { ToastService } from '@shared/services/toast.service';

import { UiButton } from '@shared/components/ui';

@Component({
  selector: 'app-editar-recurso',
  imports: [FormField, UiButton],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './editar-recurso.html',
})
export class EditarRecurso {
  private api = inject(ReservaApiService);
  private toast = inject(ToastService);

  readonly recurso = input.required<IReservaRecursoData>();
  readonly cerrar = output<IReservaRecursoData | undefined>();

  formRecurso = form(
    signal({
      nombre: '',
      descripcion: '',
      duracion_minutos: 60,
      precio: 0,
      capacidad: 1,
    }),
    (schema) => {
      required(schema.nombre, { message: 'El nombre es obligatorio' });
      maxLength(schema.nombre, 150, { message: 'Máximo 150 caracteres' });
      required(schema.duracion_minutos, { message: 'La duración es obligatoria' });
      min(schema.duracion_minutos, 1, { message: 'Mínimo 1 minuto' });
      required(schema.precio, { message: 'El precio es obligatorio' });
      min(schema.precio, 0, { message: 'El precio no puede ser negativo' });
      required(schema.capacidad, { message: 'La capacidad es obligatoria' });
      min(schema.capacidad, 1, { message: 'Mínimo 1' });
    },
  );

  constructor() {
    effect(() => {
      const r = this.recurso();
      if (r) {
        this.formRecurso().value.set({
          nombre: r.nombre,
          descripcion: r.descripcion ?? '',
          duracion_minutos: r.duracion_minutos,
          precio: r.precio,
          capacidad: r.capacidad,
        });
      }
    });
  }

  onCerrar(data?: IReservaRecursoData) {
    this.cerrar.emit(data);
  }

  guardar() {
    if (this.formRecurso().invalid()) return;
    const values = this.formRecurso().controlValue();
    this.api
      .editarRecurso(this.recurso().id, {
        ...values,
        descripcion: values.descripcion || null,
      })
      .subscribe({
        next: (data) => {
          this.toast.show('top-right', 'success', 'Éxito', 'Recurso actualizado correctamente');
          this.onCerrar(data);
        },
        error: (err) => {
          if (err.status === 401) return;
          this.toast.show(
            'top-right',
            'error',
            'Error',
            err.error?.message ?? 'No se pudo actualizar',
          );
        },
      });
  }
}
